import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, computed, signal, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { CallProgressComponent } from '../../departments/recruiting/call-progress/call-progress.component';
import { CallStatsGraphComponent } from '../../departments/recruiting/call-stats-graph/call-stats-graph.component';
import { UiModule } from 'src/app/ui/ui.module';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';
import { IconService } from 'src/app/ui/icon.service';
import { LocalAuthService } from 'src/app/auth/local-auth.service';

interface StatConfig {
  class: string;
  component: TemplateRef<any>;
}

@Component({
  selector: 'app-call-stats',
  standalone: true,
  imports: [
    CommonModule,
    UiModule,
    CallProgressComponent, 
    CallStatsGraphComponent
  ],
  templateUrl: './call-stats.component.html',
  styleUrl: './call-stats.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallStatsComponent implements OnInit, OnDestroy {
  @ViewChild('callProgress') callProgressTemplate!: TemplateRef<any>;
  @ViewChild('callStatsGraph') callStatsGraphTemplate!: TemplateRef<any>;

  private ngUnsubscribe = new Subject<void>();
  
  // Role-based computed property for PPM call goal settings access
  canEditPpmCallGoals = computed(() => {
    const user = this.auth.currentUser;
    return user ? (
      this.auth.hasAnyRole(['it', 'salesAdmin']) || 
      this.hasStaffId([91, 26, 21, 3, 106])
    ) : false;
  });

  constructor(
    public icons: IconService,
    private dataPadService: DataPadService,
    private auth: LocalAuthService
  ) {}

  ngOnInit() {
    // TODO: Fetch call stats data
  }

  updateCallGoals() {
    this.dataPadService.showPanel({
      panelName: 'updateCallGoals',
      inputData: {}
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  // Role checking helper method
  hasStaffId(staffIds: number[]): boolean {
    const user = this.auth.currentUser;
    return user ? staffIds.includes(user.newstaffId) : false;
  }
} 